import { useEffect } from 'react'

const OAuthNylasCallbackPage = () => {
  useEffect(() => {
    const query = new URLSearchParams(window.location.search)
    const code = query.get('code')

    if (code) {
      sessionStorage.setItem('nylas-code', code)
      window.location.replace(`/settings?tab=users&nylasCode=${code}`)
    } else {
      window.location.replace('/settings?tab=users&nylasError=1')
    }
  }, [])

  return <p>Processing connection with Nylas…</p>
}

export default OAuthNylasCallbackPage
